<footer class="container">
  <span class="text">Växa | 010 - 471 00 00 | <a href="mailto:info@vxa.se">info@vxa.se</a> | version 1.0.1 |</span>
  <img
    class="logo"
    src="/assets/eu-large.svg"
    alt="Europeiska jordbruksfonden för landsbygdsutveckling. Europa investerar i landsbygdsområden."
  />
</footer>
